import * as Utils from '../../../Utils';

const INVALID_CHARACTERS_REGEX = /[&$+,/:;=?@<>[\]{}|\\^~%#]/g;
const REPLACEMENT_CHARACTER = '_';

export default class RenamingStrategyHandler {
    constructor(filename, key, shouldBeRenamed = false) {
        this.filename = filename;
        this.key = key;
        this.shouldBeRenamed = shouldBeRenamed;
    }

    generateGuidFilename() {
        return `${Utils.guid()}.${Utils.extractFileExtension(this.filename)}`;
    }

    replaceInvalidCharacters() {
        return this.filename.replace(INVALID_CHARACTERS_REGEX, REPLACEMENT_CHARACTER);
    }

    handle() {
        const newFileName = this.shouldBeRenamed ? this.generateGuidFilename() : this.replaceInvalidCharacters();
        return newFileName !== this.filename ? `${this.key.slice(0, this.key.lastIndexOf('/') + 1)}${newFileName}` : this.key;
    }
}
